module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a4df852fbca02033445630d2a39d182e.png";